const useLanguages = () => {
    const formatLanguagesForAutocomplete = (lanuages = []) =>
        lanuages.map((language) => ({ label: language?.title, value: language?.title?.toLowerCase() }));
    return {
        formatLanguagesForAutocomplete
    };
};

export default useLanguages;
